import React from "react"
import { Footer, FooterText } from "../styles"

export default () => (
  <Footer>
    <FooterText>© 2020 Ioannis Angelakis</FooterText>
  </Footer>
)
